import { render, staticRenderFns } from "./productCode.vue?vue&type=template&id=251c2a5b&"
import script from "./productCode.vue?vue&type=script&lang=js&"
export * from "./productCode.vue?vue&type=script&lang=js&"
import style0 from "./productCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports